import type { IconProps } from '../types/IconProps.ts';
export const EyeClosed: IconProps = {
    name: 'EyeClosed',
    children: [
        `<path d="M21 8c0 3.31-4.03 6-9 6s-9-2.69-9-6M5 12l-3 3M19 12l3 3M9 14l-1 4M14 14l1 4" />`,
    ]
};